import { render, staticRenderFns } from "./AdditionalSection.vue?vue&type=template&id=6e3c8198"
import script from "./AdditionalSection.vue?vue&type=script&lang=js"
export * from "./AdditionalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e3c8198')) {
      api.createRecord('6e3c8198', component.options)
    } else {
      api.reload('6e3c8198', component.options)
    }
    module.hot.accept("./AdditionalSection.vue?vue&type=template&id=6e3c8198", function () {
      api.rerender('6e3c8198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/AdditionalSection.vue"
export default component.exports